var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    { attrs: { content: _vm.tooltipText, placement: "bottom" } },
    [
      _c("p", { staticClass: "data-comparison fs-3 gray-60" }, [
        _c("span", { class: _vm.getColor(_vm.stats.color) }, [
          _c(
            "span",
            { staticClass: "numbers-diff__icon-and-percent" },
            [
              _c("CompassIcon", { attrs: { icon: _vm.stats.iconClasses } }),
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.stats.percent
                      ? _vm.stats.percent + "%"
                      : _vm.$l10n.__("N/A")
                  ) +
                  "\n            "
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.stats.comparison))])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }